import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import useFormInput from "../../hooks/useFormInput";
import { changePWD } from "../javascript/function";

const PWDModal = (props) => {

  const cpwd = useFormInput("");
  const pwd = useFormInput("");
  const opwd = useFormInput("");
  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.onCloseModal}
        center
        classNames={{
          modal: "customModal",
        }}
      >
        <div className="modal-header">
          <h3 className="modal-title">Change Password</h3>
        </div>
        <div className="modal-body">
          <form className="mt-1" style={{ minWidth: "320px" }}  onSubmit={(event)=> { event.preventDefault();changePWD(props.OEM,opwd.value,pwd.value,cpwd.value);props.onCloseModal();}}>
            <div className="form-group">
              <input
                type="text"
                className="form-control mb-0"
                id="opwd"
                name="opwd"
                placeholder={"Enter Old Password"}
                {...opwd}
                autoComplete="off"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                className="form-control mb-0"
                id="pwd"
                name="pwd"
                placeholder={"Enter New Password"}
                {...pwd}
                autoComplete="off"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                className="form-control mb-0"
                id="cpwd"
                name="cpwd"
                placeholder={"Confirm Password"}
                {...cpwd}
                autoComplete="off"
                required
              />
            </div>

            <div className="sign-info">
              {/*   <div className="custom-control custom-checkbox d-inline-block">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">Remember Me</label>
                     
                     
                     </div>     */}
              <button
                type="submit"
                className="btn btn-hover"
                style={{ float: "right" }}
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default PWDModal;
